import { render, staticRenderFns } from "./pie_chart.vue?vue&type=template&id=31cad649&scoped=true&"
import script from "./pie_chart.vue?vue&type=script&lang=js&"
export * from "./pie_chart.vue?vue&type=script&lang=js&"
import style0 from "./pie_chart.vue?vue&type=style&index=0&id=31cad649&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cad649",
  null
  
)

export default component.exports